import { roleSearch } from "@/core/modules/role/search/roleSearch";
import { userSearch } from "@/core/modules/user/search/userSearch";

export const coreSearchModules = [userSearch, roleSearch];
